export default __webpack_public_path__ + "static/media/inventMgmt1Full.a74c9a86.png";